/**
 * Invite Management API
 *
 * @package Movepro CRM
 * @module InviteManagement
 */

export interface InviteTenant {
    id: number;
    slug: string;
    name: string;
    logo: string | null;
    accent: string | null;
    allow_support: boolean;
}

export interface Invite {
    id: number;
    tenant_id: number;
    title: string | null;
    created_at: string;
    tenant: InviteTenant | null;
}

interface PendingInvitesResponse {
    data: Invite[];
    meta: {
        current_page: number;
        last_page: number;
        from: number | null;
        to: number | null;
        total: number;
    };
}

async function getPendingInvites(page = 1): Promise<PendingInvitesResponse> {
    const { data } = await window.centralAxios.get<PendingInvitesResponse>('/me/invites', {
        params: { page },
    });
    return data;
}

async function acceptInvite(userTenantId: number): Promise<void> {
    await window.centralAxios.post(`/me/invites/${userTenantId}/accept`);
}

async function declineInvite(userTenantId: number): Promise<void> {
    await window.centralAxios.post(`/me/invites/${userTenantId}/decline`);
}

async function leaveTenant(tenantId: number): Promise<void> {
    await window.centralAxios.post(`/me/tenants/${tenantId}/leave`);
}

export default {
    getPendingInvites,
    acceptInvite,
    declineInvite,
    leaveTenant,
};
